import React from "react";

function NextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      style={{
        ...style,
        width: "48",
        height: "48",
        zIndex: "999",
        top: "40%",
        right: "6%",
      }}
      onClick={onClick}
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.8537 24.0001C17.8537 23.8837 17.9 23.772 17.9823 23.6897C18.0646 23.6073 18.1763 23.5611 18.2927 23.5611H28.6475L25.8843 20.7987C25.8019 20.7163 25.7556 20.6045 25.7556 20.4879C25.7556 20.3713 25.8019 20.2595 25.8843 20.1771C25.9668 20.0947 26.0786 20.0483 26.1952 20.0483C26.3117 20.0483 26.4236 20.0947 26.506 20.1771L30.0182 23.6893C30.0591 23.7301 30.0915 23.7785 30.1136 23.8318C30.1358 23.8852 30.1472 23.9424 30.1472 24.0001C30.1472 24.0579 30.1358 24.115 30.1136 24.1684C30.0915 24.2217 30.0591 24.2702 30.0182 24.3109L26.506 27.8231C26.4236 27.9056 26.3117 27.9519 26.1952 27.9519C26.0786 27.9519 25.9668 27.9056 25.8843 27.8231C25.8019 27.7407 25.7556 27.6289 25.7556 27.5123C25.7556 27.3957 25.8019 27.2839 25.8843 27.2015L28.6475 24.4391H18.2927C18.1763 24.4391 18.0646 24.3929 17.9823 24.3105C17.9 24.2282 17.8537 24.1165 17.8537 24.0001Z"
        fill="black"
      />
    </svg>
  );
}

export default NextArrow;
